import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from '../reducers/rules';

/**
 * Direct selector to the app state domain
 */

const selectRulesDomain = (state: ApplicationRootState) => {
  if (state.configurator) {
    return state.configurator.rules || initialState;
  }
  return initialState;
};

const makeSelectIsRulesLoading = () =>
  createSelector(
    selectRulesDomain,
    (substate): boolean => substate.loading,
  );

const makeSelectIsRulesReady = () =>
  createSelector(
    selectRulesDomain,
    (substate): boolean => !!substate.data,
  );

const makeSelectRules = () =>
  createSelector(
    selectRulesDomain,
    substate => {
      if (substate.data) return substate.data;
      return null;
    },
  );

export {
  selectRulesDomain,
  makeSelectRules,
  makeSelectIsRulesLoading,
  makeSelectIsRulesReady,
};
